import { catColors, pct } from "./flashTheme";

export const StackedBar = ({ current, goal, categories, testId }) => {
  if (!current) {
    return <div className="h-3.5 w-full rounded-full bg-slate-100 border border-dashed border-slate-200" data-testid={testId} />;
  }
  const colors = catColors(categories.length);
  const vals = current.values || {};
  const total = Math.max(categories.reduce((a, c) => a + (vals[c.key] || 0), 0), 100);
  return (
    <div className="space-y-1.5" data-testid={testId}>
      <div className="relative">
        <div className="h-3.5 w-full rounded-full bg-slate-100 overflow-hidden flex">
          {categories.map((c, i) => (
            <div
              key={c.key}
              className={`${colors[i]} h-full flash-grow`}
              style={{ width: `${((vals[c.key] || 0) / total) * 100}%`, animationDelay: `${i * 120}ms` }}
              title={`${c.label} ${pct(vals[c.key])}`}
            />
          ))}
        </div>
        <div className="absolute -top-1 -bottom-1 w-0.5 bg-slate-900 rounded" style={{ left: `${goal}%` }} title={`Goal ${goal}%`} />
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-slate-600">
        {categories.map((c, i) => (
          <span key={c.key} className="flex items-center gap-1.5">
            <span className={`w-2 h-2 rounded-sm ${colors[i]}`} />
            {c.label} <span className="font-mono">{pct(vals[c.key])}</span>
          </span>
        ))}
      </div>
    </div>
  );
};
